import request from '@/plugins/request';

/**
 * 获取关于我们列表
 * @param {Object} params - 请求参数，如页码等
 * @returns {Promise} - 返回Promise对象
 */
export function list(params) {
  return request({
    url: '/fronted/about/list',
    method: 'get',
    params
  });
}

/**
 * 获取关于我们详情
 * @param {string|number} id - 关于我们ID
 * @returns {Promise} - 返回Promise对象
 */
export function getDetail(id) {
  return request({
    url: `/fronted/about/getInfo/${id}`,
    method: 'get'
  });
}

/**
 * 获取关于我们分类列表
 * @param {Object} params - 请求参数，如页码等
 * @returns {Promise} - 返回Promise对象
 */
export function getCategoryList(params) {
  return request({
    url: '/fronted/about/category',
    method: 'get',
    params
  });
}

/**
 * 根据分类获取关于我们列表
 * @param {string|number} categoryId - 分类ID
 * @param {Object} params - 请求参数，如页码等
 * @returns {Promise} - 返回Promise对象
 */
export function getListByCategory(categoryId, params) {
  return request({
    url: `/fronted/about/category/${categoryId}`,
    method: 'get',
    params
  });
} 